/** The file the server built: its name and its bytes in base64 (ticket 16). */
export interface Base64File {
	fileName: string
	base64: string
}

/** Saves the server's file in the browser: its bytes as a Blob, downloaded under its name. */
export function saveRegisterFile(file: Base64File): void {
	const bytes = Uint8Array.from(atob(file.base64), (c) => c.charCodeAt(0))
	const blob = new Blob([bytes], {
		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	})
	const url = URL.createObjectURL(blob)
	const a = document.createElement('a')
	a.href = url
	a.download = file.fileName
	document.body.appendChild(a)
	a.click()
	a.remove()
	URL.revokeObjectURL(url)
}
